import { auctionsStates } from '@/febos/aduanas/auctions/views/utils/constants';
import { batchesStates } from '@/febos/aduanas/batches/views/utils/constants';
import { receiptsStates } from '@/febos/aduanas/receipts/views/utils/constants';

export default {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_GENERAL_AUCTION_INDICATORS(state, indicators) {
    state.auctionIndicators = Object.keys(indicators).map((key) => ({
      status: Number(key),
      name: auctionsStates[Number(key)].label,
      icon: auctionsStates[Number(key)].icon,
      color: auctionsStates[Number(key)].color,
      quantity: indicators[key]
    }));
  },
  SET_GENERAL_BATCH_INDICATORS(state, indicators) {
    state.batchIndicators = Object.keys(indicators).map((key) => ({
      status: Number(key),
      name: batchesStates[Number(key)].label,
      icon: batchesStates[Number(key)].icon,
      color: batchesStates[Number(key)].color,
      quantity: indicators[key]
    }));
  },
  SET_GENERAL_RECEIPTS_INDICATORS(state, indicators) {
    state.receiptIndicators = Object.keys(indicators).map((key) => ({
      status: Number(key),
      name: receiptsStates[Number(key)].label,
      color: receiptsStates[Number(key)].color,
      quantity: indicators[key]
    }));
  }
};
